var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"wh-ib",class:`wh-ib--${_vm.tone}`,attrs:{"type":"button","title":_vm.label,"aria-label":_vm.label,"data-action":_vm.action,"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', $event)}}},[_c('v-icon',{attrs:{"size":"18"}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }